import React, { useState } from "react";
import "./css/styles.css";
import AlertBox from "../Utills/AlertBox";
import { Trans, withTranslation } from "react-i18next";

const initialValue = {
  alert: false,
  head: "",
  message: "",
  success: false,
  action: null,
};

const CopyCodes = ({ data }) => {
  const [alertOptions, setAlertOptions] = useState(initialValue);

  const handleAlert = (open, head, message, callback, success) => {
    setAlertOptions((prev) => ({
      ...prev,
      alert: open,
      head: head,
      message: message,
      callback: callback,
      success: success,
    }));
  };

  const copyToClipBoard = (value) => {
    navigator.clipboard.writeText(value).then(() => {
      handleAlert(
        true,
        "Text copied",
        "The text is copied to the clipboard",
        null,
        true
      );
    });
  };

  return (
    <div className="codes_container">
      <div className="user-input-wrp amb25 code-inp-wrap">
        <br />
        <input
          type="text"
          id="name"
          className="inputText accept"
          placeholder=" "
          required
          value={data.acceptance_code}
        />
        <span className="floating-label label-font">
          {" "}
          <Trans i18nKey="Acceptance code">Acceptance Code </Trans>
        </span>
        <div
          className="copy-icon"
          onClick={() => copyToClipBoard(data.acceptance_code)}
        >
          <i class="fa-regular fa-copy"></i>
        </div>
      </div>
      <div className="user-input-wrp amb25 code-inp-wrap">
        <br />
        <input
          type="text"
          id="name"
          className="inputText reject"
          placeholder=" "
          required
          value={data.rejection_code}
        />
        <span className="floating-label label-font"> <Trans i18nKey="Rejection code">Rejection Code </Trans></span>
        <div
          className="copy-icon"
          onClick={() => copyToClipBoard(data.rejection_code)}
        >
          <i class="fa-regular fa-copy"></i>
        </div>
      </div>
      <AlertBox options={alertOptions} />
    </div>
  );
};

export default CopyCodes;
